import React from 'react'
import TranslateText from '../../TranslateText'
import EntryTime from '../../PositionColumns/EntryTime'
import { Text } from '../../../../styles/reactnative'
import UserTag from '../../UserTag'
import IPText from '../../IPText'
import { Button, Image, Popover, Tag } from 'antd'
import { TagWrap } from './styles'
import PCInfoDetailCell from './PCInfoDetailCell'

export const column_log_page = (mutate, setModal) => {
	return [
		{
			title: '로그ID',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			width: 100,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '시간',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 130,
			align: 'center',
			render: (text, record) => {
				return <EntryTime time={record?.created_at} />
			},
		},
		{
			title: '프론트시간',
			dataIndex: 'time',
			key: 'time',
			width: 50,
			align: 'left',
			render: (text, record) => {
				try {
					const parsed = JSON.parse(record?.data)
					if (parsed?.time) {
						return <EntryTime time={parsed?.time} offset={0} />
					}

				} catch (e) {
				}
			},
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			key: 'user_id',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return (
					<UserTag
						userid={text}
						email={record?.email}
						nickname={record?.fullname || record?.nickname}
						phone={record?.phone}
						onClick={() => {
							setModal(text)
						}}
					/>
				)
			},
		},
		{
			title: '내역',
			dataIndex: 'log',
			key: 'log',
			align: 'left',
			render: (text, record) => {
				return <TranslateText text={text} data={record} />
			},
		},
		{
			title: '비고',
			dataIndex: 'data',
			align: 'center',
			width: 200,
			render: (text, record) => {
				let print = <></>

				if (record?.log.includes('GT')) {
					const split = record?.data?.split(':')
					if (split?.length > 1) {
						if (split[8] == '1') {
							print = <Text>청산</Text>
						}
						if (split[8] == '2') {
							print = <Text>익절</Text>
						}
						if (split[8] == '4') {
							print = <Text>전종목청산</Text>
						}
						if (split[8] == '3') {
							print = <Text>현종목청산</Text>
						}
						if (split[8] == '6') {
							print = <Text>손절</Text>
						}
						if (split[7] == '1') {
							print = <Text>MIT</Text>
						}
						if (split[7] == '10') {
							print = <Text>F10</Text>
						}
						if (split[7] == '11') {
							print = <Text>F11</Text>
						}
					}
				} else if (record?.log.includes('MIT')) {
					print = <Text>MIT실행</Text>
				}



				try {
					const parsed = JSON.parse(record?.data)


					let num = ''
					if (parsed?.f) {
						num = ' #' + parsed?.f
					}

					if (parsed?.window) {
						print = (
							<>
								{print}
								<Tag color="orange">
									{parsed?.window}
									{num}
								</Tag>
							</>
						)
					} else {
						if (num) {
							print = (
								<>
									{print}
									<Tag color="orange">{num}번창</Tag>
								</>
							)
						}
					}

					let version = <></>

					if (parsed?.version) {
						version = <Tag color='green' style={{ maxWidth: 50 }}>v{parsed?.version}</Tag>
					}

					if (parsed?.isMobile || parsed?.device == 'MTS') {
						return <TagWrap>{version}<Tag color="red" style={{ maxWidth: 50 }}>모바일</Tag>{print}</TagWrap>
					} else if (parsed?.device == 'HTS') {
						return <TagWrap>{version}<Tag color="blue" style={{ maxWidth: 50 }}>HTS</Tag>{print}</TagWrap>
					}

					return <TagWrap>{version}{print}</TagWrap>
				} catch (e) {
					return <TagWrap>{print}<Text>{!print && text}</Text></TagWrap>
				}
			},
		},
		{
			title: '아이피',
			dataIndex: 'ip',
			align: 'center',
			key: 'ip',
			width: 150,
			render: (text, record) => {
				return <IPText ip={text} mutate={mutate} />
			},
		},
		{
			title: '코드',
			dataIndex: 'log',
			key: 'log',
			width: 50,
			align: 'left',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '상세',
			dataIndex: 'data',
			key: 'data',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return <PCInfoDetailCell text={text} record={record} />
			},
		},
		{
			title: '스샷',
			dataIndex: 'screenshot',
			key: 'screenshot',
			width: 50,
			render: (text, record) => {
				try {
					const parsed = JSON.parse(record?.data)

					if (parsed?.sc) {
						return <Popover
							title={<EntryTime time={parsed?.sct} offset={0}/>}
							content={
								<Image
									src={parsed.sc}
								></Image>
							}>
							<Button size={'small'}>O</Button>
						</Popover>
					} else {
						return <></>
					}
				} catch (e) {
					return <></>
				}
			},
		}
	]
}
